/* @flow */
import styled from 'styled-components'
import THEME from './Pricing2.theme'
import WMContainer from '@website/common/components/WMContainer'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  @media only screen and (min-width: 769px) {
    padding: ${({ isEditing }) => (isEditing ? '150px 0 80px 0' : ' 80px 0')};
  }
  .control-container {
    width: 100%;
  }
`

const Heading = styled.h1`
  color: ${getStyleForProp('heading')};
  margin-bottom: 0;
  ${getTextStyleByAlignment};
  width: 100%;
`

const Paragraph = styled.p`
  color: ${getStyleForProp('paragraph')};
  margin-top: 20px;
  ${getTextStyleByAlignment};
  width: 100%;
`

const Title = styled.h2`
  margin: 20px 0 12px 0;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.tertiaryNormal};
  text-align: center;
  width: 100%;
`

const WmCustomContainer = styled(WMContainer)`
  display: flex;
  flex-direction: column;
  .rf-badge-svg {
    position: absolute;
    top: -3px;
    right: -3px;
  }
`

const PricingCardsContainer = styled.div`
  margin: 0 0 -20px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  @media only screen and (max-width: 1068px) {
    margin-bottom: -40px;
  }
  @media only screen and (max-width: 770px) {
    margin-bottom: -20px;
  }
  @media only screen and (max-width: 600px) {
    margin-bottom: 0px;
  }
`

const PricingCardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & > .control-container:nth-child(1) {
    margin: 20px 0 12px 0;

    & > p {
      margin: 0;
    }
  }

  & > .control-container:nth-child(3) {
    margin: 16px 0 0 0;

    & > p {
      margin: 0;
    }
  }
`

const PricingCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;

  & > .control-container {
    padding: 16px 0;

    & > .control-container {
      p {
        padding: 0;
      }
    }
  }
`

const PricingCardFooter = styled.div`
  margin-top: auto;
`

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0 0 40px 0;
  > :first-child {
    margin-top: 0;
  }
  .control-container:nth-child(2) {
    margin-top: 20px;
    p {
      margin-top: 0;
    }
  }
`

const Price = styled.p`
  color: ${({ theme }) => theme.palette.tertiaryDark};
  font-weight: bold;
  text-align: center;
  width: 100%;
`

const PriceCardWrapper = styled.article`
  display: flex;
  @media only screen and (min-width: 769px) {
    padding: ${props => (!props.isPrimary ? '20px 0 20px 0' : 'initial')};
  }
  > .control-container:first-child {
    margin-top: 20px;
    margin-bottom: 12px;
    h2 {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`

const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  @media only screen and (min-width: 769px) {
    padding: ${props => (props.isPrimary ? '20px 0 20px 0' : 'initial')};
  }
`

const ButtonWrapper = styled.div`
  transform: ${props => (props.isPrimary ? 'translateY(-2px)' : 'initial')};
  margin-top: auto;
  .link {
    border-radius: ${getStyleForProp('buttonRadius')};
    ${props =>
      getStyleForProp(
        props.isPrimary ? 'buttonBackground' : 'buttonBackgroundSecondary'
      )(props)};
    background-repeat: no-repeat;
    text-decoration: none;
    width: 100%;
    max-width: 260px;
    padding: 0 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    text-align: center;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    text-decoration: none !important;
    font-weight: 400;
    background-repeat: no-repeat !important;
    font-size: 14px;
    display: block;
  }
`

const PriceCard = styled.div`
  width: 280px;
  max-width: 280px;
  margin: 20px;
  box-sizing: border-box;
  background-color: white;
  box-sizing: border-box;
  min-width: 280px;
  box-shadow: ${props =>
    getStyleForProp(props.isPrimary ? 'raisedShadow' : 'shadow')};
  box-shadow: ${props =>
    getStyleForProp(props.isPrimary ? 'raisedShadow' : 'shadow')};
  height: ${props => (props.isEditing ? 'initial' : 'auto')};
  flex: 1;
  transition: all 0.2s linear;
  padding: 40px 20px;
  border-radius: ${getStyleForProp('borderRadius')};
  border: ${getStyleForProp('border')};
  display: flex;
  flex-direction: column;
  position: relative;
  @media only screen and (max-width: 600px) {
    margin: 2rem 0 0 0;
  }
`

const PerDate = styled.p`
  color: ${({ theme }) => theme.palette.tertiaryDark};
  margin: 16px 0 0 0;
  text-align: center;
  width: 100%;
`

const Option = styled.p`
  width: 100%;
  color: ${({ theme }) => theme.palette.tertiaryNormal};
  text-align: center;
  padding: 16px 0;
  margin-top: 0;
`

const Span = styled.span``

export default {
  Span,
  Title,
  Heading,
  StyledContainer,
  WmCustomContainer,
  PricingCardsContainer,
  PricingCardHeader,
  PricingCardContent,
  HeaderContainer,
  PricingCardFooter,
  Paragraph,
  PriceCard,
  Price,
  PerDate,
  Option,
  PriceCardWrapper,
  ContentBody,
  ButtonWrapper
}
